// import getConfig from 'next/config';
import { setCookie } from '../../hooks/useCookie';
import useLocalStorage, { setLocalStorageWithPrefix } from '../../hooks/useLocalStorage';
import { createAcquisitionProspect } from '../../integration/acquisition.api';

// const { publicRuntimeConfig } = getConfig();
// const { removeLocalStorage } = useLocalStorage();

const localStore = useLocalStorage();

export const handleYes = async (openAccountCheck, setLoginModal, setExistingCustomerCheckValue) => {
  localStore.removeLocalStorage('portIn');
  // const origin = publicRuntimeConfig.NEXT_PUBLIC_OPENCMS;
  // window.location.href = `${origin}/mobile/bill-pay`;
  openAccountCheck.disable();
  setExistingCustomerCheckValue(true);
  setLoginModal(true);
  setLocalStorageWithPrefix('ION_EXISTING_CUSTOMER', true);
  // openAccountCheck.disable();
};

export const handleNo = async (
  e,
  openAccountCheck,
  openKeepNumberCheck,
  setExistingCustomerCheckValue,
  graphql,
  dispatch
) => {
  e.stopPropagation();
  openAccountCheck.disable();
  openKeepNumberCheck.enable();
  setExistingCustomerCheckValue(true);
  dispatch({ type: 'ENABLE_LOGIN_BUTTON', payload: true });
  if (!localStore.getLocalStorage('PROSPECTUUID')) {
    try {
      const acq = await createAcquisitionProspect({ graphql });
      localStore.setLocalStorage('PROSPECTUUID', acq.createAcquisitionProspect);
      setCookie('ACQ', 'reference', acq.createAcquisitionProspect);
      setCookie('ION', 'cart_Type', 'NEW_ACQUISITION');
    } catch (error) {
      console.error(error);
    }
  }
  setLocalStorageWithPrefix('ION_EXISTING_CUSTOMER', false);
};
